import axios, { AxiosRequestConfig } from 'axios'

import { ReceiptType, IReceipt, ISummaries } from '@/types/receipt'
import { parseReceiptFromResponse } from '@/utils/parser'

export const getReceipts = async (
  receiptType: ReceiptType,
  lastId?: number,
  query?: any,
): Promise<[IReceipt[], number]> => {
  const config: AxiosRequestConfig = {
    params: {
      limit: 1000,
      receiptType,
    },
  }
  if (lastId) {
    config.params.lastId = lastId
  }
  if (query !== undefined) {
    config.params = {
      ...config.params,
      ...query,
    }
  }
  const instance = axios.create(config)
  try {
    const response = await instance.get<[IReceipt[], number]>('receipts')
    const [receipts, total] = response.data
    const _receipts = receipts.map(parseReceiptFromResponse)
    return [_receipts, total]
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.getReceipts')
  }
}

export const getReceipt = async (
  id: number,
  { needReProcess }: { needReProcess: boolean } = { needReProcess: false },
): Promise<IReceipt> => {
  const config = {
    params: {
      needReProcess,
    },
  }
  try {
    const response = await axios.get<IReceipt>(`receipts/${id}`, config)
    return parseReceiptFromResponse(response.data)
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.getReceipt')
  }
}

export const updateReceipt = async (receipt: IReceipt): Promise<IReceipt> => {
  try {
    const response = await axios.put<IReceipt>(
      `receipts/${receipt.id}`,
      receipt,
    )
    return parseReceiptFromResponse(response.data)
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.updateReceipt')
  }
}

export const getSnapShot = async (): Promise<ISummaries> => {
  const config = {
    timeout: 1000 * 60 * 10, // 10 min
    params: {},
  }
  try {
    const response = await axios.get<ISummaries>('receipts/snapShot', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.getSnapShot')
  }
}

export const getSummaries = async (date: number): Promise<ISummaries> => {
  const config = {
    timeout: 1000 * 60 * 10, // 10 min
    params: {
      date,
    },
  }
  try {
    const response = await axios.get<ISummaries>('receipts/summaries', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.getSummaries')
  }
}

export const getContributers = async (
  query: any,
): Promise<[IReceipt[], number]> => {
  const config: AxiosRequestConfig = {
    params: {
      limit: 1000,
      ...query,
    },
  }
  const instance = axios.create(config)
  try {
    const response = await instance.get<[IReceipt[], number]>(
      'receipts/contributers',
    )
    const [receipts, total] = response.data
    const _receipts = receipts
      .sort((p: any, n: any) => {
        return p.id < n.id ? -1 : 1
      })
      .map(parseReceiptFromResponse)
    return [_receipts, total]
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.getContributers')
  }
}

export const genMock = async (
  id: number,
  questionnaireId: number,
): Promise<string> => {
  try {
    const response = await axios.get<string>(
      `receipts/mock-questionnaire/${id}/${questionnaireId}`,
    )
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.receipts.genMock')
  }
}
